import App from "./App";
import Vue from "vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import { abilitiesPlugin } from "@casl/vue";
import { ability } from "./utils/ability";
import { sync } from "vuex-router-sync";
import { i18n } from "./plugins/i18n";
sync(store, router);
Vue.config.productionTip = false;
Vue.config.performance = true;
Vue.use(abilitiesPlugin, ability);

/* eslint-disable no-new */
new Vue({
    router,
    vuetify,
    store,
    i18n,
    render: h => h(App),
}).$mount("#app");
